import { createApi } from '@reduxjs/toolkit/query/react';
import { dynamicFetchBaseFactory } from '@vs/rtk/utils';
import { rtkCacheTTL } from '@vs/utils/constants';

import { referenceOfMeta } from './init';

export const vsAccount2ApiBase = createApi({
  reducerPath: 'vsAccount2GenApi',
  keepUnusedDataFor: rtkCacheTTL.normal,
  refetchOnMountOrArgChange: rtkCacheTTL.normal,
  baseQuery: dynamicFetchBaseFactory(referenceOfMeta, {
    credentials: 'include',
  }),
  endpoints: () => ({}),
  serializeQueryArgs: ({ queryArgs, endpointName }) => {
    const userId = referenceOfMeta._getUserIdFunc?.() || null;
    const baseKey = `${endpointName}(${JSON.stringify(queryArgs)})`;
    return userId ? `${baseKey}-user:${userId}` : baseKey;
  },
});
